angular.module('jv.Common.Directives.VonageVideoRecorder', [])
.directive('jvVonageVideoRecorder', [ '$rootScope',
     function($rootScope) {
        return {
            restrict: 'A',
            link: function(scope, elm){
                var publisherOptions = {
                            insertMode: 'append',
                            width: '100%',
                            height: '100%',
                            fitMode: 'contain',
                            showControls: false,
                            facingMode:'user'
                          };
              //For FitMode possible values are {cover,contain} - used contain because
              //"cover" — The video is cropped if its dimensions do not match those of the DOM element.
              //We dont want videos to be cropped if DOM dimension does not match
              //"contain" - The video is letterboed if its dimensions do not match those of the DOM element.
              //style: {buttonDisplayMode: 'off'} - To remove mic icon. 
              //Added condition to avoid triggering multiple calls of initPublisher event
                if(!$rootScope.$$listenerCount['initPublisher']){
                    $rootScope.$on('initPublisher', function() {
                        var publisher = OT.initPublisher('recorder', publisherOptions);
                        //Putting publisher in rootscope to access it in controller and start publishing
                        $rootScope.vonagePublisher = publisher;
                    });
                }
            }
        };
    }
]);